<template>
  <a-modal
    title="仓库盘存"
    :width="visible_list_style? 1080: 580"
    :visible="visible"
    :confirmLoading="loading"
    @cancel="() => { $emit('cancel') }"
    @ok="() => { $emit('ok') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form">
        <a-form-item label="仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            style="width: 100%"
            :not-found-content="fetching ? undefined : null"
            :default-active-first-option="false"
            :filter-option="false"
            show-search
            allow-clear
            v-decorator="['warehouse_id', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
            placeholder="请输入仓库"
            @search="this.warehouseSearch"
            @change="handleWarehouseChange"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="d in warehouseList" :key="d.id" :value="d.id">
              {{ d.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="公司" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="false">
          <a-select
            style="width: 100%"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            show-search
            allow-clear
            v-decorator="['corporation_id', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
            placeholder="请输入公司"
            :default-active-first-option="false"
            @search="handleCorporationSearch"
          >
            <a-select-option v-for="d in corporationList" :key="d.id" :value="d.id">
              {{ d.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { STable } from '@/components'

import { warehouse_list } from '@/api/c_wms_warehouse'
import { corporation_list } from '@/api/corporation'
import debounce from 'lodash/debounce'

export default {
  name: 'WarehouseTakeInventoryForm',
  components: {
    STable
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    model: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    this.warehouseSearch = debounce(this.handleWarehouseSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible_list_style: false,
      warehouseList: [],
      corporationList: [],
      form: this.$form.createForm(this),
      fetching: false,
      loading: false
    }
  },
  created () {
    this.handleWarehouseSearch(undefined)
  },
  methods: {
    handleWarehouseSearch (value) {
      this.warehouseList = []
      this.fetching = true
      warehouse_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.warehouseList = result
      }).finally(() => {
        this.fetching = false
      })
    },
    handleWarehouseChange (value) {
      if (value === undefined) {
        this.handleWarehouseSearch(undefined)
      }
    },
    handleCorporationSearch (value) {
      corporation_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.corporationList = !value ? [] : result
      })
    }
  }
}
</script>
